module.exports = __webpack_public_path__ + "static/decoration-circle-9a0b99277f4e899d9c640631006f3119.svg";